/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class GraphSaveParamsService extends BaseService {
  constructor() {
    super(constants.SAVE_GRAPH_PARAMS, 'saveGraphParamsStatus');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { graphId, params } = payload;

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').post(
        `/graphs/${graphId}/config/params`,
        { params },
        { headers: enhancedHeaders }
      );
    }
    return this.getClient('aiadmin').post(`/graphs/${graphId}/config/params`, { params }, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data && data.success) {
      const notification = {
        open: true,
        type: 'success',
        message: data.message || 'Parameters saved successfully!'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('graphParamsModel').setSaveSuccess(data);
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: data?.message || 'Failed to save parameters'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('graphParamsModel').setError('Failed to save parameters', 'save');
    }
  }

  handleError(error) {
    const { response } = error;
    let errorMessage = 'Failed to save parameters';

    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      errorMessage = data?.message || errorMessage;
    } else if (error.message === 'timeout of 60000ms exceeded') {
      errorMessage = 'Request timeout. Please try again.';
    }

    const notification = {
      open: true,
      type: 'error',
      message: errorMessage
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
    Framework.getStoreRegistry().getStore('graphParamsModel').setError(errorMessage, 'save');
  }
}
